import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export { generateImpressionForMinm2Licenses, getMinLicenseCount, previewMinm2Licenses } from '@coursera-web/wes-common';

// WES Payment Gateway - BT/Stripe
export const generateImpressionForPg = () => EnterpriseExperiments.get('paymentGatewayToBeDisplayed');
export const isStripeEnabled = () =>
  EnterpriseExperiments.preview('paymentGatewayToBeDisplayed') === 'stripeEnterpriseWes';

// WES Self Serve Invoicing Flow
export const generateImpressionForSelfServeInvoicing = () => EnterpriseExperiments.get('isSelfServeInvoice');
export const previewImpressionForSelfServeInvoicing = () => EnterpriseExperiments.preview('isSelfServeInvoice');

// WES Differential Pricing
export const generateImpressionForDifferentialPricing = () => EnterpriseExperiments.get('showDifferentialPricing');
export const previewImpressionForDifferentialPricing = () => EnterpriseExperiments.preview('showDifferentialPricing');

/**
 * This is a feature gate for tiered pricing not an experiment. Will be cleaned up before launch.
 * @returns
 */
export const previewTieredPricingEnabled = () => EnterpriseExperiments.preview('tieredPricingEnabled');
